export default "__VITE_ASSET__CJse6$0k__"